require('./focusIf');
module.exports = 'focus-if';



//////////////////
// WEBPACK FOOTER
// ./~/ng-focus-if/index.js
// module id = 6
// module chunks = 0